<template>
  <v-container fluid>
    <report-title :title="options.title" class="mb-2" />
    <report-sub-category :tabs="options.tabs" @select-tab="onTabSelect" />
    <v-form ref="form" v-model="valid" class="mb-4 mt-4">
      <v-row justify="space-around" class="px-0">
        <v-col cols="4" v-if="options.organizations && options.organizations.length">
          <v-autocomplete
            v-model="organizationId"
            :items="options.organizations"
            item-text="nameRu"
            item-value="id"
            dense
            filled
            :rules="[v => v != null || 'Выберите организацию']"
            label="Организация"
          />
        </v-col>
        <v-col cols="3">
          <report-date-picker :rangeValue="range.start" />
        </v-col>
        <v-col cols="3">
          <report-date-picker :rangeValue="range.end" />
        </v-col>
        <v-col cols="2" align="center">
          <v-btn
            rounded
            color="primary"
            dark
            :loading="loading"
            @click="loadReport"
          >
            Показать отчёт
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <report-kpi-bar />
    <report-chart :chartOptions="chartOptions" :series="series" />
    <report-alert />
    <v-row>
      <v-col>
        <v-data-table
          :headers="options.headers"
          :items="options.data"
          :loading="loading"
          class="elevation-1"
          :footer-props="{
            itemsPerPageAllText: 'Все',
            itemsPerPageText: 'Строк на страницу'
          }"
        >
          <template v-slot:progress>
            <v-progress-linear color="primary" indeterminate />
          </template>
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} из {{ items.itemsLength }}
          </template>
          <template v-slot:item.dateTime="{ item }">
            <td>{{ item.dateTime | date }}</td>
          </template>
          <template v-slot:item.regDateTime="{ item }">
            <td>{{ item.regDateTime | date }}</td>
          </template>
          <template v-slot:item.temperature="{ item }">
            {{ item.temperature != null ? item.temperature.toFixed(2) : '—' }}
          </template>
          <template v-slot:item.volume="{ item }">
            {{ item.volume != null ? item.volume.toFixed(2) : '—' }}
          </template>
          <template v-slot:item.pressure="{ item }">
            {{ item.pressure != null ? item.pressure.toFixed(2) : '—' }}
          </template>
          <template v-slot:no-data>
            <div class="text-center pa-4 grey--text">
              По выбранным фильтрам данных не найдено. Задайте период и организацию и нажмите «Показать отчёт».
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue } from "vue-property-decorator";
import { mapActions, mapState } from "vuex";
import { format, startOfYear } from "date-fns";

export default Vue.extend({
  name: "CReportGasProduce",
  components: {
    ReportTitle: () => import("@/components/report/ReportTitle.vue"),
    ReportSubCategory: () => import("@/components/report/ReportSubCategory.vue"),
    ReportDatePicker: () => import("@/components/report/ReportDatePicker.vue"),
    ReportKpiBar: () => import("@/components/report/ReportKPIBar.vue"),
    ReportChart: () => import("@/components/report/ReportChart.vue"),
    ReportAlert: () => import("@/components/report/ReportAlert.vue")
  },
  data() {
    return {
      valid: true,
      organizationId: 0,
      selectedOperationTypeId: null
    };
  },
  computed: {
    ...mapState("report", ["range", "loading", "chartOptions", "series"]),
    options() {
      return this.$store.state.report.optionsGas;
    }
  },
  methods: {
    ...mapActions("report", [
      "fetchGasOrganizations",
      "fetchGasData",
      "resetGasReport"
    ]),
    onTabSelect(tab) {
      this.selectedOperationTypeId = tab.operationTypeId;
      this.resetGasReport();
      const dateFrom = format(startOfYear(Date.now()), "yyyy-MM-dd");
      const dateTo = format(Date.now(), "yyyy-MM-dd");
      this.$store.commit("report/RANGE", { start: dateFrom, end: dateTo });
      this.fetchGasData({
        path: "",
        params: {
          organizationId: this.organizationId,
          date_from: dateFrom,
          date_to: dateTo,
          operationTypeId: this.selectedOperationTypeId
        }
      });
    },
    async loadReport() {
      if (!this.$refs.form.validate()) return;
      const start = this.range.start.value;
      const end = this.range.end.value;
      if (!start || !end) return;
      const params = {
        organizationId: this.organizationId,
        date_from: start,
        date_to: end,
        operationTypeId: this.selectedOperationTypeId
      };
      await this.fetchGasData({ path: "", params });
    }
  },
  async mounted() {
    const dateFrom = format(startOfYear(Date.now()), "yyyy-MM-dd");
    const dateTo = format(Date.now(), "yyyy-MM-dd");
    await this.fetchGasOrganizations();
    this.resetGasReport();
    this.$store.commit("report/RANGE", { start: dateFrom, end: dateTo });
    const firstTab = this.options.tabs[0];
    this.selectedOperationTypeId = firstTab.operationTypeId;
    this.$store.commit("report/CURRENT_TAB", firstTab);
    await this.fetchGasData({
      path: "",
      params: {
        organizationId: 0,
        date_from: dateFrom,
        date_to: dateTo,
        operationTypeId: this.selectedOperationTypeId
      }
    });
  }
});
</script>
